export default __webpack_public_path__ + "static/banner-mobile-application-development1-ezgif.com-avif-to-jpg-converter-fb679ce19be11982641439a4ea1ccf41.jpg";